module.exports = __webpack_public_path__ + "img/grip-dots-vertical.842a6b.svg";